(function() {
  function q(selector, ctx) { return (ctx || document).querySelector(selector); }
  function qa(selector, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(selector)); }

  var INTENTS = [
    {
      id: 'order_tracking',
      triggers: ['track my order', 'where is my order', 'where is my package', 'track order', 'order tracking'],
      answer: 'I can help with that. You can look up your shipment with a tracking number, or with your order number and email.',
      followUps: ['Use tracking number', 'Use order number and email']
    },
    {
      id: 'tracking_not_updated',
      triggers: ['tracking not updated', 'tracking has not updated', 'stuck shipment', 'no tracking update'],
      answer: 'If tracking has not moved for a few days, that can still be normal. If there has been no movement for 5 days or more, I can help you check the shipment and guide you to support if needed.',
      followUps: ['Track my order', 'Contact support']
    },
    {
      id: 'delivered_but_missing',
      triggers: ['delivered but missing', 'package says delivered', 'delivered not received', 'marked delivered'],
      answer: 'If the parcel is marked delivered, please check around the delivery location, with neighbors, with household members, and any safe place or reception area. If you still cannot find it, I can help you contact support.',
      followUps: ['Track my order', 'Contact support']
    },
    {
      id: 'shipping_times',
      triggers: ['shipping times', 'how long shipping', 'delivery time', 'when will it arrive'],
      answer: 'Shipping times depend on your destination and the production stage of your order. Tracking usually gives the clearest live update once the parcel is on the way.',
      followUps: ['Track my order', 'Contact support']
    },
    {
      id: 'frame_options',
      triggers: ['frame options', 'difference between no frame and framed', 'what is diy frame', 'framed or no frame'],
      answer: 'No Frame means the canvas is shipped rolled in a tube. DIY Frame means the canvas is also shipped rolled, but with a separate wooden frame kit that you assemble after painting. Framed means the canvas arrives already stretched on the frame and ready to hang.',
      followUps: ['Best size for my photo', 'Contact support']
    },
    {
      id: 'size_recommendation',
      triggers: ['what size should i choose', 'best size for my photo', 'size recommendation', 'which size'],
      answer: 'For many portraits, 40x50 cm with 36 colors is a strong starting point. For narrow vertical photos, 30x50 cm with 36 colors is often a good fit.',
      followUps: ['Preview detail question', 'Contact support']
    },
    {
      id: 'preview_detail_limitations',
      triggers: ['preview detail', 'eyes look different', 'photo detail', 'face details', 'preview question'],
      answer: 'Paint by numbers simplifies the original image into a limited number of colors and sections. Smaller facial details can become less precise, especially when the photo was taken from farther away. Closer photos usually create better detail in facial features.',
      followUps: ['Best size for my photo', 'Contact support']
    },
    {
      id: 'dark_photo_blending_question',
      triggers: ['dark photo', 'blended sky', 'low contrast', 'dark sky'],
      answer: 'Very dark or softly blended areas can be harder to separate clearly because the design needs distinct paint sections. That can reduce contrast in those parts of the image.',
      followUps: ['Preview detail question', 'Contact support']
    },
    {
      id: 'photo_change_after_order',
      triggers: ['change my photo', 'photo change', 'replace photo', 'change image after ordering'],
      answer: 'If your order has already entered production or batch processing, it may no longer be possible to change the photo.',
      followUps: ['Contact support']
    },
    {
      id: 'dry_paints',
      triggers: ['dry paints', 'damaged paints', 'paints arrived dry', 'damaged supplies'],
      answer: 'Thank you for reaching out, and I am sorry to hear that some of your paints arrived dry. That is not the experience we want for our customers. Please use the support form below and we will help you with the next steps.',
      followUps: ['Contact support']
    },
    {
      id: 'contact_support',
      triggers: ['contact support', 'email support', 'support', 'need help'],
      answer: 'I can help you send a message to support right here.',
      followUps: ['Open support form']
    }
  ];

  var SUGGESTIONS = [
    'Where is my order?',
    'My tracking has not updated',
    'My package says delivered but I do not have it',
    'What is the difference between no frame and framed?',
    'What size should I choose?',
    'Can I change my photo after ordering?',
    'My paints are dry',
    'Can I contact support?'
  ];

  var QUICK_ACTIONS = [
    'Track my order',
    'Shipping times',
    'Frame options',
    'Best size for my photo',
    'My tracking has not updated',
    'Contact support'
  ];

  function normalize(str) {
    return String(str || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function scoreSuggestion(query, candidate) {
    var qNorm = normalize(query);
    var cNorm = normalize(candidate);
    if (!qNorm || !cNorm) return -1;
    if (cNorm.indexOf(qNorm) === 0) return 100 - (cNorm.length - qNorm.length);
    if (cNorm.indexOf(qNorm) > -1) return 80 - cNorm.indexOf(qNorm);
    var qWords = qNorm.split(' ');
    var score = 0;
    for (var i = 0; i < qWords.length; i++) {
      if (qWords[i] && cNorm.indexOf(qWords[i]) > -1) score += 12;
    }
    return score > 0 ? score : -1;
  }

  function findIntent(input) {
    var text = normalize(input);
    var best = null;
    var bestScore = -1;

    INTENTS.forEach(function(intent) {
      intent.triggers.forEach(function(trigger) {
        var score = scoreSuggestion(text, trigger);
        if (score > bestScore) {
          bestScore = score;
          best = intent;
        }
      });
    });

    return bestScore >= 10 ? best : null;
  }

  function createEl(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (typeof text === 'string') el.textContent = text;
    return el;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function initChat(root) {
    if (!root || root.__pbnSupportReady) return;
    root.__pbnSupportReady = true;

    var config = {
      apiBaseUrl: root.getAttribute('data-api-base-url') || 'https://preview.paintbynumbersking.com',
      title: root.getAttribute('data-title') || 'Contact support',
      subtitle: root.getAttribute('data-subtitle') || '',
      trackingLabel: root.getAttribute('data-tracking-label') || 'Shopify tracking data'
    };

    var messages = q('[data-support-messages]', root);
    var input = q('[data-support-input]', root);
    var send = q('[data-support-send]', root);
    var suggestions = q('[data-support-suggestions]', root);
    var quickActions = q('[data-support-quick-actions]', root);
    var helper = q('[data-support-helper]', root);

    var state = {
      selectedSuggestion: -1,
      pendingFlow: null,
      trackingDraft: {},
      latestTracking: null,
      escalationOpen: false
    };

    function setHelper(text) {
      if (!helper) return;
      helper.textContent = text || 'Press Enter to send. Use Arrow keys to browse suggestions.';
    }

    function formatDateTime(value) {
      if (!value) return '';
      try {
        return new Date(value).toLocaleString();
      } catch (e) {
        return value;
      }
    }

    function humanizeStatus(status) {
      var map = {
        label_created: 'Label created',
        in_transit: 'In transit',
        out_for_delivery: 'Out for delivery',
        delivered: 'Delivered',
        exception: 'Carrier exception',
        delayed: 'Delayed',
        stale_tracking: 'Tracking delayed',
        unknown: 'Unknown'
      };
      return map[status] || 'Unknown';
    }

    function appendMessage(kind, htmlOrText, options) {
      options = options || {};
      var row = createEl('div', 'pbn-support-message' + (kind === 'user' ? ' is-user' : ''));
      if (kind !== 'user') {
        row.appendChild(createEl('div', 'pbn-support-avatar', 'PB'));
      }

      var bubble = createEl('div', 'pbn-support-bubble');
      if (options.isHtml) {
        bubble.innerHTML = htmlOrText;
      } else {
        bubble.appendChild(createEl('p', '', htmlOrText));
      }

      row.appendChild(bubble);
      messages.appendChild(row);
      messages.scrollTop = messages.scrollHeight;
      return bubble;
    }

    function appendTyping() {
      var row = createEl('div', 'pbn-support-message');
      row.setAttribute('data-typing-row', '1');
      row.appendChild(createEl('div', 'pbn-support-avatar', 'PB'));
      var bubble = createEl('div', 'pbn-support-bubble');
      bubble.innerHTML = '<div class="pbn-support-typing" aria-label="Assistant is typing"><span></span><span></span><span></span></div>';
      row.appendChild(bubble);
      messages.appendChild(row);
      messages.scrollTop = messages.scrollHeight;
    }

    function removeTyping() {
      qa('[data-typing-row="1"]', messages).forEach(function(node) { node.remove(); });
    }

    function renderQuickActions(targetBubble, items) {
      if (!items || !items.length) return;
      var wrap = createEl('div', 'pbn-support-followups');
      items.forEach(function(label) {
        var btn = createEl('button', 'pbn-support-chip', label);
        btn.type = 'button';
        btn.addEventListener('click', function() {
          handleUserText(label, true);
        });
        wrap.appendChild(btn);
      });
      targetBubble.appendChild(wrap);
    }

    function renderTrackingCard(data) {
      var location = data.lastEvent && data.lastEvent.location ? escapeHtml(data.lastEvent.location) : 'Not available';
      var timestamp = data.lastEvent && data.lastEvent.timestamp ? escapeHtml(formatDateTime(data.lastEvent.timestamp)) : 'Not available';
      var orderNumber = escapeHtml(data.orderNumber || 'Not available');
      var carrier = escapeHtml(data.carrier || config.trackingLabel);
      var trackingNumber = escapeHtml(data.trackingNumber || 'Not available');
      var trackingUrl = data.trackingUrl ? escapeHtml(data.trackingUrl) : '';
      var lastEventDescription = escapeHtml((data.lastEvent && data.lastEvent.description) || 'Not available');
      var recommendedAction = data.recommendedAction ? escapeHtml(data.recommendedAction) : '';
      var card = ''
        + '<div class="pbn-tracking-card" role="region" aria-label="Shipment tracking details">'
        + '<div class="pbn-tracking-head">'
        +   '<strong>Tracking result</strong>'
        +   '<span class="pbn-tracking-status">' + escapeHtml(humanizeStatus(data.status)) + '</span>'
        + '</div>'
        + '<div class="pbn-tracking-grid">'
        +   '<div class="pbn-tracking-item"><span class="pbn-tracking-label">Order</span><div class="pbn-tracking-value">' + orderNumber + '</div></div>'
        +   '<div class="pbn-tracking-item"><span class="pbn-tracking-label">Carrier</span><div class="pbn-tracking-value">' + carrier + '</div></div>'
        +   '<div class="pbn-tracking-item"><span class="pbn-tracking-label">Tracking number</span><div class="pbn-tracking-value">' + trackingNumber + '</div></div>'
        +   '<div class="pbn-tracking-item"><span class="pbn-tracking-label">Last update</span><div class="pbn-tracking-value">' + timestamp + '</div></div>'
        +   '<div class="pbn-tracking-item"><span class="pbn-tracking-label">Last event</span><div class="pbn-tracking-value">' + lastEventDescription + '</div></div>'
        +   '<div class="pbn-tracking-item"><span class="pbn-tracking-label">Location</span><div class="pbn-tracking-value">' + location + '</div></div>'
        + '</div>'
        + (trackingUrl ? '<p><a class="pbn-support-link" href="' + trackingUrl + '" target="_blank" rel="noopener">Open carrier tracking page</a></p>' : '')
        + (recommendedAction ? '<p>' + recommendedAction + '</p>' : '')
        + '</div>';
      return card;
    }

    function showEscalationForm(prefillTopic) {
      if (state.escalationOpen) return;
      state.escalationOpen = true;
      var tracking = state.latestTracking || {};
      var bubble = appendMessage('bot', '<p>Please share your details below and our team will help you.</p>', { isHtml: true });
      var form = createEl('form', 'pbn-support-form');
      form.innerHTML = ''
        + '<div class="pbn-support-form-grid">'
        +   '<div class="pbn-support-form-field"><label>Name</label><input type="text" name="name" required></div>'
        +   '<div class="pbn-support-form-field"><label>Email</label><input type="email" name="email" required></div>'
        + '</div>'
        + '<div class="pbn-support-form-grid">'
        +   '<div class="pbn-support-form-field"><label>Order number</label><input type="text" name="order_number" value="' + escapeHtml(tracking.orderNumber || '') + '"></div>'
        +   '<div class="pbn-support-form-field"><label>Tracking number</label><input type="text" name="tracking_number" value="' + escapeHtml(tracking.trackingNumber || '') + '"></div>'
        + '</div>'
        + '<div class="pbn-support-form-grid">'
        +   '<div class="pbn-support-form-field"><label>Topic</label><select name="topic">'
        +       '<option value="tracking_stale">Tracking delay</option>'
        +       '<option value="delivered_but_missing">Delivered but missing</option>'
        +       '<option value="damaged_or_dry_paints">Damaged or dry paints</option>'
        +       '<option value="order_change_request">Order change request</option>'
        +       '<option value="general_support">General support</option>'
        +   '</select></div>'
        +   '<div class="pbn-support-form-field"><label>Screenshot (optional)</label><input type="file" name="screenshot" accept="image/*,.pdf"></div>'
        + '</div>'
        + '<div class="pbn-support-form-field"><label>Message</label><textarea name="message" required></textarea></div>'
        + '<div class="pbn-support-form-actions">'
        +   '<button type="submit" class="pbn-support-button-primary">Send to support</button>'
        +   '<button type="button" class="pbn-support-button-secondary" data-close-support-form>Close</button>'
        + '</div>'
        + '<div class="pbn-support-feedback" data-support-form-feedback></div>';

      bubble.appendChild(form);
      var topicField = q('select[name="topic"]', form);
      if (topicField && prefillTopic) topicField.value = prefillTopic;
      var messageField = q('textarea[name="message"]', form);
      if (messageField && tracking.status === 'delivered') {
        messageField.value = 'My tracking says delivered, but I cannot find the package.';
      }

      q('[data-close-support-form]', form).addEventListener('click', function() {
        state.escalationOpen = false;
        form.remove();
      });

      form.addEventListener('submit', function(event) {
        event.preventDefault();
        var feedback = q('[data-support-form-feedback]', form);
        feedback.className = 'pbn-support-feedback';
        feedback.textContent = 'Sending your message...';

        var data = new FormData(form);
        data.append('carrier', tracking.carrier || '');
        data.append('shipment_status', tracking.status || '');
        data.append('last_event_description', tracking.lastEvent ? tracking.lastEvent.description || '' : '');
        data.append('last_event_location', tracking.lastEvent ? tracking.lastEvent.location || '' : '');
        data.append('days_since_update', tracking.daysSinceLastUpdate != null ? String(tracking.daysSinceLastUpdate) : '');

        fetch(config.apiBaseUrl.replace(/\/$/, '') + '/api/support-email', {
          method: 'POST',
          body: data
        }).then(function(response) {
          return response.json().catch(function() { return {}; });
        }).then(function(payload) {
          if (!payload || payload.success !== true) {
            throw new Error(payload && payload.error ? payload.error : 'We could not send your support request.');
          }
          feedback.className = 'pbn-support-feedback is-success';
          feedback.textContent = 'Your message has been sent. Our team will get back to you by email.';
          appendMessage('bot', 'Your support message is on the way. Thank you for the details.');
          state.escalationOpen = false;
        }).catch(function(error) {
          feedback.className = 'pbn-support-feedback is-error';
          feedback.textContent = error && error.message ? error.message : 'We could not send your message right now.';
        });
      });
    }

    function askTrackingMethod() {
      state.pendingFlow = { type: 'tracking_choice' };
      var bubble = appendMessage('bot', 'I can check live shipment details for you. Choose the easiest way to continue.');
      renderQuickActions(bubble, ['Use tracking number', 'Use order number and email']);
    }

    function requestTrackingLookup() {
      var draft = state.trackingDraft || {};
      var body = new URLSearchParams();
      if (draft.trackingNumber) body.set('tracking_number', draft.trackingNumber);
      if (draft.orderNumber) body.set('order_number', draft.orderNumber);
      if (draft.email) body.set('email', draft.email);

      appendTyping();

      fetch(config.apiBaseUrl.replace(/\/$/, '') + '/api/support/tracking-lookup', {
        method: 'POST',
        body: body
      }).then(function(response) {
        return response.json().catch(function() { return {}; });
      }).then(function(payload) {
        removeTyping();
        if (!payload || payload.success !== true || !payload.tracking) {
          throw new Error(payload && payload.error ? payload.error : 'We could not load tracking details.');
        }
        state.latestTracking = payload.tracking;
        var bubble = appendMessage('bot', '<p>Here is the latest tracking update I found.</p>' + renderTrackingCard(payload.tracking), { isHtml: true });
        if (payload.tracking.status === 'delivered') {
          renderQuickActions(bubble, ['Contact support']);
        } else if (payload.tracking.requiresEscalation) {
          renderQuickActions(bubble, ['Contact support']);
        } else {
          renderQuickActions(bubble, ['Contact support', 'Shipping times']);
        }
        state.pendingFlow = null;
        state.trackingDraft = {};
      }).catch(function(error) {
        removeTyping();
        var bubble = appendMessage('bot', error && error.message ? error.message : 'We could not load tracking details right now.');
        renderQuickActions(bubble, ['Contact support']);
        state.pendingFlow = null;
      });
    }

    function handleTrackingFlow(text) {
      if (!state.pendingFlow) return false;
      var value = String(text || '').trim();
      if (state.pendingFlow.type === 'tracking_choice') {
        if (/tracking number/i.test(value)) {
          state.pendingFlow = { type: 'tracking_number' };
          appendMessage('bot', 'Please enter your tracking number.');
          return true;
        }
        if (/order number/i.test(value)) {
          state.pendingFlow = { type: 'order_number' };
          appendMessage('bot', 'Please enter your order number.');
          return true;
        }
      } else if (state.pendingFlow.type === 'tracking_number') {
        state.trackingDraft.trackingNumber = value;
        appendMessage('bot', 'Thank you. Let me check the shipment now.');
        requestTrackingLookup();
        return true;
      } else if (state.pendingFlow.type === 'order_number') {
        state.trackingDraft.orderNumber = value;
        state.pendingFlow = { type: 'order_email' };
        appendMessage('bot', 'Great. Please enter the email used for the order.');
        return true;
      } else if (state.pendingFlow.type === 'order_email') {
        state.trackingDraft.email = value;
        appendMessage('bot', 'Thank you. Let me check the shipment now.');
        requestTrackingLookup();
        return true;
      }
      return false;
    }

    function respondToIntent(intent) {
      if (!intent) {
        var bubble = appendMessage('bot', 'I can help with tracking, shipping questions, frame options, preview expectations, and support requests.');
        renderQuickActions(bubble, QUICK_ACTIONS);
        return;
      }

      if (intent.id === 'order_tracking') {
        askTrackingMethod();
        return;
      }

      if (intent.id === 'contact_support' || intent.id === 'dry_paints') {
        var bubble = appendMessage('bot', intent.answer);
        renderQuickActions(bubble, ['Open support form']);
        return;
      }

      var bubble = appendMessage('bot', intent.answer);
      if (intent.followUps && intent.followUps.length) {
        renderQuickActions(bubble, intent.followUps);
      }
    }

    function handleUserText(text, skipEcho) {
      var cleaned = String(text || '').trim();
      if (!cleaned) return;

      if (!skipEcho) {
        appendMessage('user', cleaned);
      }

      if (/^open support form$/i.test(cleaned) || /^contact support$/i.test(cleaned)) {
        appendMessage('bot', 'Please complete the form below and our team will help you by email.');
        showEscalationForm((state.latestTracking && state.latestTracking.supportTopic) || 'general_support');
        return;
      }

      if (handleTrackingFlow(cleaned)) {
        return;
      }

      if (/^track my order$/i.test(cleaned) || /^use tracking number$/i.test(cleaned) || /^use order number and email$/i.test(cleaned)) {
        if (/^track my order$/i.test(cleaned)) {
          askTrackingMethod();
        } else if (/tracking number/i.test(cleaned)) {
          state.pendingFlow = { type: 'tracking_number' };
          appendMessage('bot', 'Please enter your tracking number.');
        } else {
          state.pendingFlow = { type: 'order_number' };
          appendMessage('bot', 'Please enter your order number.');
        }
        return;
      }

      var intent = findIntent(cleaned);
      respondToIntent(intent);
    }

    function renderSuggestions(query) {
      var text = String(query || '').trim();
      suggestions.innerHTML = '';
      state.selectedSuggestion = -1;

      if (!text) {
        suggestions.classList.remove('is-visible');
        return;
      }

      var ranked = SUGGESTIONS.map(function(item) {
        return { text: item, score: scoreSuggestion(text, item) };
      }).filter(function(item) {
        return item.score > -1;
      }).sort(function(a, b) {
        return b.score - a.score;
      }).slice(0, 5);

      if (!ranked.length) {
        suggestions.classList.remove('is-visible');
        return;
      }

      ranked.forEach(function(item, index) {
        var button = createEl('button', 'pbn-support-suggestion', item.text);
        button.type = 'button';
        button.setAttribute('role', 'option');
        button.addEventListener('click', function() {
          input.value = item.text;
          suggestions.classList.remove('is-visible');
          handleUserText(item.text);
          input.value = '';
        });
        if (index === 0) {
          button.classList.add('is-active');
          state.selectedSuggestion = 0;
        }
        suggestions.appendChild(button);
      });

      suggestions.classList.add('is-visible');
    }

    function moveSuggestion(delta) {
      var items = qa('.pbn-support-suggestion', suggestions);
      if (!items.length) return;
      state.selectedSuggestion = Math.max(0, Math.min(items.length - 1, state.selectedSuggestion + delta));
      items.forEach(function(item, index) {
        item.classList.toggle('is-active', index === state.selectedSuggestion);
      });
    }

    function selectActiveSuggestion() {
      var items = qa('.pbn-support-suggestion', suggestions);
      if (!items.length) return false;
      var active = items[state.selectedSuggestion] || items[0];
      if (!active) return false;
      active.click();
      return true;
    }

    function bindQuickActions() {
      QUICK_ACTIONS.forEach(function(label) {
        var btn = createEl('button', 'pbn-support-chip', label);
        btn.type = 'button';
        btn.addEventListener('click', function() {
          handleUserText(label, true);
        });
        quickActions.appendChild(btn);
      });
    }

    send.addEventListener('click', function() {
      var value = input.value;
      suggestions.classList.remove('is-visible');
      handleUserText(value);
      input.value = '';
      renderSuggestions('');
    });

    input.addEventListener('input', function() {
      renderSuggestions(input.value);
    });

    input.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        moveSuggestion(1);
        return;
      }
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        moveSuggestion(-1);
        return;
      }
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        if (suggestions.classList.contains('is-visible') && selectActiveSuggestion()) {
          return;
        }
        send.click();
      }
    });

    document.addEventListener('click', function(event) {
      if (!root.contains(event.target)) {
        suggestions.classList.remove('is-visible');
      }
    });

    bindQuickActions();
    setHelper();

    var welcome = appendMessage('bot', 'Hi, I am here to help with order tracking, shipping questions, frame options, photo guidance, and support.');
    renderQuickActions(welcome, QUICK_ACTIONS);
  }

  function boot() {
    qa('[data-pbn-contact-support-chat]').forEach(initChat);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
